import { Action } from 'redux';

import { isSetContentExplorerToolbarStateAction } from '~src/spacesPlatform/actions/SetContentExplorerToolbarStateAction';
import { ContentExplorerToolbarState } from '~src/spacesPlatform/state/ContentExplorerState';

const throwNotImplemented = () => {
    throw new Error('Function not implemented.');
};

export const contentExplorerToolbarDefaultState: ContentExplorerToolbarState = {
    contentSort: [{
        field: 'name',
        ascending: false
    }],
    showDatasourceViewTypeDropDown: false,
    hasTextSearchParameter: false,
    filtersApplied: false,
    showAdvancedFilterButton: false,
    supportedDisplayModes: ['list'],
    hideSelection: false,
    changeViewMode: throwNotImplemented,
    advancedFilterButtonClickHandler: throwNotImplemented,
    datasourceViewTypeSelected: throwNotImplemented,
};

export const contentExplorerToolbarReducer = (
    previousState: ContentExplorerToolbarState = contentExplorerToolbarDefaultState,
    action: Action
): ContentExplorerToolbarState => {
    if (isSetContentExplorerToolbarStateAction(action)) {
        return {
            ...action.state
        };
    }

    return previousState;
};